import React from 'react';
import classNames from 'classnames';
import { Modal as AntModal } from 'antd';
import styles from './index.module.scss';

type Props = {
  open: boolean;
  width?: string | number;
  height?: string | number;
  children?: React.ReactNode;
  closable?: boolean;
  maskStyle?: React.CSSProperties; // 支持外部定义遮罩的样式
  wrapClassName?: string;
  bodyClassName?: string;
  destroyOnClose?: boolean;
  keyboard?: boolean;
  maskClosable?: boolean;
  onCancel: (e: any) => void;
  closeIcon?: React.ReactNode;
  zIndex?: number;
};

function Modal(props: Props) {
  const {
    open,
    children,
    wrapClassName,
    bodyClassName,
    destroyOnClose,
    keyboard,
    maskClosable,
    onCancel,
    closable = true,
  } = props;

  return (
    <AntModal
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      className={styles.modal}
      maskClosable={maskClosable}
      footer={null}
      closable={closable}
      open={open}
      wrapClassName={wrapClassName}
      onCancel={onCancel}
      destroyOnClose={destroyOnClose}
      centered
      keyboard={keyboard}
    >
      <div className={classNames(styles.modalBody, bodyClassName)}>
        { children }
      </div>
    </AntModal>
  );
}

export default Modal;
